import { motion, useReducedMotion } from 'framer-motion';

const bioCopy = 'First-generation computer scientist most interested in complexity theory algorithm design and blockchains.';

export default function Home() {
    const shouldReduceMotion = useReducedMotion();

    return (
        <div className="home-page">
            <motion.div
                className="bio"
                initial={shouldReduceMotion ? false : { opacity: 0, y: -36 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{
                    duration: shouldReduceMotion ? 0 : 0.55,
                    ease: [0.22, 1, 0.36, 1],
                }}
            >
                {bioCopy}
            </motion.div>
        </div>
    );
}
